export type Locale = 'fr' | 'en' | 'it' | 'es' | 'de';

export const availableLocales: Locale[] = ['fr', 'en', 'it', 'es', 'de'];

type Section = {
    label: string;
    links: Array<{
        label: string;
        url: string;
    }>;
};

export const getSections = (locale: Locale): Array<Section> => [
    {
        label: 'menu.request_manager.title',
        links: [
            {
                label: 'menu.request_manager.pipeline',
                url: '/request-manager/process/sales',
            },
            {
                label: 'menu.request_manager.todo',
                url: '/request-manager/todo/today',
            },
            {
                label: 'menu.request_manager.inbox',
                url: '/request-manager/inbox',
            },
            {
                label: 'menu.request_manager.message_templates',
                url: '/request-manager/templates/list',
            },
        ],
    },
    {
        label: 'menu.offer_manager.title',
        links: [
            {
                label: 'menu.offer_manager.itineraries',
                url: '/offer-manager',
            },
        ],
    },
    {
        label: 'menu.tipi.title',
        links: [
            {
                label: 'menu.tipi.library',
                url: '/trip-planner/library',
            },
        ],
    },
    {
        label: 'menu.cash_manager.title',
        links: [
            {
                label: 'menu.cash_manager.accounting',
                url: 'https://pro.evaneos-travel.com/transaction/#/payments',
            },
            // {
            //     label: 'menu.cash_manager.transfers',
            //     url: '/cash-manager',
            // },
        ],
    },
    {
        label: 'menu.insights.title',
        links: [
            {
                label: 'menu.insights.statistics',
                url: '/agency-insights',
            },
            {
                label: 'menu.insights.customer_satisfaction',
                url: '/agency-insights',
            },
            {
                label: 'menu.insights.better_trip_index',
                url: '/agency-insights',
            },
        ],
    },
    {
        label: 'menu.agency_manager.title',
        links: [
            {
                label: 'menu.agency_manager.active_accounts',
                url: '/agency-manager',
            },
            {
                label: 'menu.agency_manager.agency_capacity',
                url: '/agency-manager/capacity',
            },
            {
                label: 'menu.agency_manager.main_contacts',
                url: '/agency-manager/contacts/main',
            },
            {
                label: 'menu.agency_manager.legal_information',
                url: '/agency-legal-information',
            },
        ],
    },
    {
        label: 'menu.tools.title',
        links: [
            {
                label: 'menu.tools.partner_connect',
                url: 'https://travelsuite.evaneos.com/agency-manager/community',
            },
            {
                label: 'navbar.help_center',
                url: `https://travelsuite.evaneos.com/knowledge-base?locale=${locale}`,
            },
        ],
    },
];
